import React from 'react';

const BookmarkIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill="#F2F8FD" />
      <path
        d="M24.8199 10H15.1799C13.0499 10 11.3199 11.74 11.3199 13.86V27.95C11.3199 29.75 12.6099 30.51 14.1899 29.64L19.0699 26.93C19.5899 26.64 20.4299 26.64 20.9399 26.93L25.8199 29.64C27.3999 30.52 28.6899 29.76 28.6899 27.95V13.86C28.6799 11.74 26.9499 10 24.8199 10ZM22.4999 19.4H17.4999C17.0899 19.4 16.7499 19.06 16.7499 18.65C16.7499 18.24 17.0899 17.9 17.4999 17.9H22.4999C22.9099 17.9 23.2499 18.24 23.2499 18.65C23.2499 19.06 22.9099 19.4 22.4999 19.4Z"
        fill="#333333"
      />
    </svg>
  );
};

export default BookmarkIcon;
